import { c as _c } from "react/compiler-runtime";
import { getErrorMessage } from '@onefootprint/request';
import { useTranslation } from 'react-i18next';
type ErrorProps = {
  error: unknown;
  testID?: string;
};
const ERROR_MESSAGE_MAPPING = {
  'Not allowed: required permission is missing: CanDecrypt': 'decrypt-permission-error'
};

/** The error's message, with a missing decrypt permission explained in words. */
const useErrorMessage = error => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let errorMessage;
  let t1;
  if ($[1] !== error) {
    errorMessage = getErrorMessage(error);
    t1 = Object.entries(ERROR_MESSAGE_MAPPING).find(t2 => {
      const [pattern] = t2;
      return errorMessage.includes(pattern);
    })?.[1];
    $[1] = error;
    $[2] = errorMessage;
    $[3] = t1;
  } else {
    errorMessage = $[2];
    t1 = $[3];
  }
  const translationKey = t1;
  let t2;
  if ($[4] !== errorMessage || $[5] !== t || $[6] !== translationKey) {
    t2 = translationKey === "decrypt-permission-error" ? t(_temp) : errorMessage;
    $[4] = errorMessage;
    $[5] = t;
    $[6] = translationKey;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
const ErrorComponent = t0 => {
  const $ = _c(5);
  const {
    error,
    testID
  } = t0;
  const displayMessage = useErrorMessage(error);
  let t1;
  if ($[0] !== displayMessage) {
    t1 = <p className="text-body-2 text-tertiary">{displayMessage}</p>;
    $[0] = displayMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1 || $[3] !== testID) {
    t2 = <div data-testid={testID} className="flex flex-col gap-3 p-5">{t1}</div>;
    $[2] = t1;
    $[3] = testID;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { useErrorMessage };
export default ErrorComponent;
function _temp($) {
  return $.decryptPermissionError;
}